import {
  Car,
  DollarSign,
  ArrowLeftRight,
  Truck,
  UserCircle,
  ShieldCheck,
  Search,
  MapPin,
  CreditCard,
  Shield,
  Lock,
  Sparkles,
  AlertTriangle,
  MessageCircle,
  FileText,
  Building2,
} from 'lucide-react';

export const FAQ_CATEGORIES = [
  { id: 'buying', icon: Car },
  { id: 'finding', icon: Search },
  { id: 'financing', icon: DollarSign },
  { id: 'payments', icon: CreditCard },
  { id: 'selling', icon: ArrowLeftRight },
  { id: 'delivery', icon: Truck },
  { id: 'storeVisit', icon: MapPin },
  { id: 'warranty', icon: Shield },
  { id: 'sourcing', icon: Sparkles },
  { id: 'account', icon: UserCircle },
  { id: 'security', icon: Lock },
  { id: 'recalls', icon: AlertTriangle },
  { id: 'afterPurchase', icon: ShieldCheck },
  { id: 'contactSupport', icon: MessageCircle },
  { id: 'policiesLegal', icon: FileText },
  { id: 'aboutMyCarSlot', icon: Building2 },
];

export const FAQ_ITEMS = {
  buying: [
    'browseInventory',
    'pricingTransparent',
    'scheduleTestDrive',
    'interestedInButton',
    'carfaxOnListing',
    'inspection150Points',
    'auctionToOwn',
    'vehicleHistory',
    'certifiedQuality',
    'holdVehicle',
    'outOfState',
    'depositRequired',
  ],
  finding: [
    'howItWorks',
    'buyingStepsOverview',
    'rightBudget',
    'compareTool',
    'savedSearchAlerts',
    'liveChatHelp',
    'similarVehicles',
    'shopByType',
    'newVsUsed',
    'helpChoosing',
  ],
  financing: [
    'preQual',
    'getFinancedRequirements',
    'lendmark',
    'calculator',
    'calculatorOnCarPage',
    'softCredit',
    'downPayment',
    'coSigner',
    'refinance',
    'rateLock',
  ],
  payments: [
    'firstPayment',
    'paymentMethods',
    'payOffEarly',
    'missedPayment',
    'autopaySetup',
    'changeDueDate',
    'payoffQuote',
  ],
  selling: [
    'instantOffer',
    'sellVsTradePages',
    'tradeInProcess',
    'payDifference',
    'offerExpire',
    'negativeEquity',
    'paperworkNeeded',
    'sellWithoutBuying',
  ],
  delivery: [
    'deliveryOptions',
    'zipDeliveryEstimate',
    'deliveryCost',
    'pickup',
    'deliveryStates',
    'trackDelivery',
    'deliveryInspection',
    'tempTags',
  ],
  storeVisit: [
    'scheduleVisit',
    'signInToBook',
    'whatToBring',
    'walkIns',
    'howLongVisit',
    'bringPassenger',
    'storeHours',
  ],
  warranty: [
    'factoryWarranty',
    'warrantyPolicyPage',
    'extendedPlans',
    'whatIsCovered',
    'transferWarranty',
    'claimProcess',
    'exclusions',
  ],
  sourcing: [
    'programOverview',
    'sourcingFee',
    'payWithSquare',
    'readFeeAgreement',
    'howLong',
    'cancelRequest',
    'specifyOptions',
    'outOfBudget',
  ],
  account: [
    'createAccount',
    'profileTabs',
    'appointments',
    'wishlist',
    'manageSavedSearches',
    'uploadDocuments',
    'resetPassword',
    'updateProfile',
    'deleteAccount',
    'emailNotifications',
  ],
  security: [
    'passwordAccount',
    'secureFinanceApplication',
    'dataPrivacy',
    'suspiciousContact',
    'twoFactor',
    'sharedComputer',
    'reportFraud',
  ],
  recalls: [
    'openRecalls',
    'recallRepair',
    'checkRecall',
    'recallBeforeDelivery',
    'manufacturerRecall',
    'fleetRecalls',
  ],
  afterPurchase: [
    'returns',
    'returnsPolicyPage',
    'serviceHelp',
    'documents',
    'insuranceProof',
    'tempPlate',
    'lenderLien',
    'satisfactionSurvey',
    'satisfactionSurveyLink',
  ],
  contactSupport: [
    'howToReachUs',
    'phoneAndEmail',
    'businessHours',
    'contactForm',
    'bestChannel',
    'visitLocation',
    'chatSupport',
  ],
  policiesLegal: [
    'privacyPolicy',
    'termsOfService',
    'cookiesPolicy',
    'shippingPolicyPage',
    'returnsPolicyPage',
    'warrantyPolicyPage',
    'findAllPolicies',
  ],
  aboutMyCarSlot: [
    'whoWeAre',
    'whatWeSell',
    'ourLocation',
    'whyChooseUs',
    'aboutPage',
    'howWeHelp',
  ],
};

export function isValidCategory(categoryId) {
  return Boolean(categoryId && FAQ_ITEMS[categoryId]);
}

export function isValidQuestion(categoryId, questionId) {
  return isValidCategory(categoryId) && FAQ_ITEMS[categoryId].includes(questionId);
}

export function getCategoryMeta(categoryId) {
  return FAQ_CATEGORIES.find((category) => category.id === categoryId) ?? null;
}
